import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    exact
    path="/consumer/apps/:appType"
    component={AsyncPage}
  />,
];
